const MOBILE_USER_AGENT_REGEX =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

export const isMobileDevice = () => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const ua = navigator.userAgent || '';
  if (MOBILE_USER_AGENT_REGEX.test(ua)) {
    return true;
  }

  const hasTouch = navigator.maxTouchPoints > 0;
  const isCoarsePointer = typeof window.matchMedia === 'function'
    ? window.matchMedia('(pointer: coarse)').matches
    : false;
  const smallViewport = Math.min(window.innerWidth, window.innerHeight) <= 900;

  return hasTouch && isCoarsePointer && smallViewport;
};
